import { useEffect } from 'react';

import LoginBankid from '@vb-django/components/login/content/bankid';
import LoginCode from '@vb-django/components/login/content/code';
import LoginMain from '@vb-django/components/login/content/main';
import LoginStart from '@vb-django/components/login/content/start';
import { useLogin } from '@vb-django/components/login/context/LoginContext';

export const AccountStep = () => {
  const LoginContext = useLogin();

  useEffect(() => {
    LoginContext.setData((prev) => ({ ...prev, no_redirect: true }));
  }, []);

  return (
    <div className="flex h-full w-full flex-col items-center justify-center">
      <div className="h-full max-h-[350px] w-full max-w-[450px] lg:h-[500px] lg:max-h-none lg:w-[600px] lg:max-w-none lg:pt-20">
        {LoginContext.view === 'start' && <LoginStart />}
        {LoginContext.view === 'bankid' && <LoginBankid />}
        {LoginContext.view === 'code' && <LoginCode />}
        {LoginContext.view === 'main' && <LoginMain />}
      </div>
    </div>
  );
};
